import { BackButton, CardButton } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { useDispatch, useSelector } from "react-redux";
import { getHasCustomOnboarding } from "@microdoing/shared/services/client/selectors";
import {
  changeSignupInput,
  signupOnboardingEndRequest,
} from "@microdoing/shared/services/signup/actions";
import MbtiSelector from "./MbtiSelector";
import theme from "app/Theme/Theme";
import { WebSignupMbti } from "./WebSignupMBTI";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import normalize from "app/utils/normalize";

const styles = StyleSheet.create({
  backButton: {
    alignSelf: "flex-start",
    marginBottom: 25,
    marginTop: 15,
  },
  main: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: theme.colors["neutral.white"],
    flex: 1,
    paddingHorizontal: widthPercentageToDP("5%"),
  },
  middleView: {
    flex: 1,
    maxWidth: normalize(10),
  },
  button: {
    width: "100%",
    height: 55,
    marginTop: 10,
    marginBottom: 25,
  },
});

const SignupMBTI = ({ navigation }) => {
  const mbti = useSelector(state => state.signup.mbti);
  const hasCustomOnboarding = useSelector(getHasCustomOnboarding);
  const dispatch = useDispatch();

  const goNext = () => {
    if (!hasCustomOnboarding) return navigation.navigate("SignupSliders");
    dispatch(signupOnboardingEndRequest());
  };

  const onChangeMbtiScore = mbti => {
    changeSignupInput({ mbti });
  };

  const renderBody = () => {
    return (
      <>
        <Text style={styles.infos}>
          {i18n.t("personalization")}
          <Text style={styles.optional}>{i18n.t("optional")}</Text>
        </Text>
        <View style={styles.middleView}>
          <MbtiSelector
            roundStyle
            selectedOption={mbti}
            onSelectOption={onChangeMbtiScore}
          />
        </View>
      </>
    );
  };

  if (isWebDesktop) {
    return (
      <WebSignupMbti
        body={renderBody()}
        isButtonDisable={false}
        goNext={goNext}
      />
    );
  }

  return (
    <View style={styles.main}>
      <BackButton
        onPress={() => navigation.goBack()}
        style={styles.backButton}
      />
      {renderBody()}
      <CardButton
        onPress={goNext}
        buttonPropStyle={styles.button}
        text={i18n.t("next")}
      />
    </View>
  );
};

export default SignupMBTI;
